// Minimal interactivity. Most behavior is handled by Shopify's native forms.
document.addEventListener('DOMContentLoaded', () => {
  // Variant selector: update price when selection changes
  const forms = document.querySelectorAll('[data-product-form]');
  forms.forEach((form) => {
    const variantsScript = form.querySelector('[data-variants]');
    if (!variantsScript) return;
    const variants = JSON.parse(variantsScript.textContent);
    const selects = form.querySelectorAll('select[data-option]');
    const variantInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-price]');
    const update = () => {
      const chosen = Array.from(selects).map((s) => s.value);
      const match = variants.find((v) =>
        v.options.every((o, i) => o === chosen[i])
      );
      if (match) {
        variantInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
      }
    };
    selects.forEach((s) => s.addEventListener('change', update));
  });
});
